export { };

import { parse } from "node-html-parser";
import {
  instituteProps,
  jsonFilePath,
  partnerStatuses,
  getBrandTitle,
  assetClassBasedOnBrandForAnonymous
} from "@/common";
import { XMLParser, XMLBuilder } from "fast-xml-parser";
import { URL } from "./url";
import { sitemapPath, removalsPath } from "@/common";
import * as fs from "fs";
import { pingOldProfile } from "@/api";
import { filterSitemap } from "./filterSitemap";
import { rewriteSitemapDomain } from "./rewriteSitemapDomain";
import { buildSearchUrl } from "./buildSearchUrl";

const {
  brand,
  environment,
  basePEIURL,
  canonicalPEIURL,
  search: searchConfig,
  shouldGenerateSitemap,
  routes: { lpFundCommitment },
  investmentAppetiteLink,
} = URL;
const specialCharRegex = /[`~!@#$%^&*()_|+\=?;:'"’,.<>\{\}\[\]\\\/]/gi;
const htmlTagsRegex = /<[^>]+>/g;
const urlRegex = /^(https?|ftp|file):\/\//i;

export const isAbsoluteUrl = (url: any) => {
  return urlRegex.test(url);
};

export const parseText = (text: string) => {
  return parse(text).textContent.replace(htmlTagsRegex, "") || "";
};

declare global {
  interface String {
    formatString(replaceWith?: string): string;
    replaceToAny(from: string, to: string): string;
  }
}

//Remove any special characters, remove double spaces, add special character in single space
String.prototype.formatString = function (replaceWith = "-"): string {
  return this.replaceAll(specialCharRegex, "")
    .replaceAll("  ", " ")
    .replaceAll(" ", replaceWith)
    .toLowerCase()
    .trim();
};

String.prototype.replaceToAny = function (from: "", to: ""): string {
  return this.replaceAll(from, to);
};

export const sortByDate = (x: any, y: any, dateProp: any, order: string = "asc") => {
  if (order === "asc") {
    return new Date(x[dateProp]).valueOf() - new Date(y[dateProp]).valueOf();
  } else {
    return new Date(y[dateProp]).valueOf() - new Date(x[dateProp]).valueOf();
  }
};

export const sortByAlphabetOrder = (x: any, y: any, prop: any, charsToRemove: string) =>
  x[prop].replaceToAny(charsToRemove, "").localeCompare(y[prop].replaceToAny(charsToRemove, ""));

export const getCHProfileRecords = async (
  brand: string,
  doFormat = true,
  traillingSpacesReplaceChar = "-"
): Promise<instituteProps[]> => {
  // Load the updated JSON file
  return new Promise(async (resolve, reject) => {
    const path = jsonFilePath;
    await fs.readFile(path, "utf8", async (err: any, CHProfiles: any) => {
      if (err) {
        console.error(err);
        reject([] as unknown as instituteProps[]);
      }
      const { Profiles } = JSON.parse(CHProfiles);
      let allProfile: instituteProps[] = Profiles;

      if (environment !== "prod") {
        //apply check to buid only pages provided in threshold
        const noOfProfile = process.env.BUILD_PROFILE_THRESHOLD ? Number(process.env.BUILD_PROFILE_THRESHOLD) : 10;
        allProfile = allProfile.slice(0, noOfProfile)
      }

      if (environment === "stage") {
        allProfile.push({
          Institution: "Jason's All Datapoints Institution",
          ID: "institution:9hw66",
          PartnerStatus: "LP/GP",
        });
        allProfile.push({
          Institution: "Jason's No Data Institution",
          ID: "institution:9i0df",
          PartnerStatus: "LP/GP",
        });
      }
      const updatedResponse = doFormat
        ? allProfile.map((profile) => {
          return {
            ...profile,
            Institution: profile.Institution.formatString(traillingSpacesReplaceChar),
          };
        })
        : Profiles;
      resolve(updatedResponse as unknown as instituteProps[]);
    });
  });
};
export const generateRandomChar = (min = 5, max = 12, char = "-") => {
  let outputSymbol = "";
  const randomRange = Math.floor(Math.random() * (max - min) + min);
  for (let random = 1; random <= randomRange; random++) {
    outputSymbol = outputSymbol + char;
  }
  return outputSymbol;
};

const data = {
  loggedIn: true,
  goldBundle: true,
  platinumTrialBundle: true,
  platinum_bundle: true,
  gold_trial_bundle: true,
  creditRnAProfileViews: 0,
  heading: "You are viewing a preview of the articles and data available",
  anonymousUserType: "anonymous",
  bronzeNotReachedLTLUserType: "bronzeNotReachedLTL",
  bronzeReachedLTLUserType: "bronzeReachedLTL",
  goldNotReachedLTLUserType: "goldNotReachedLTL",
  goldReachedLTLUserType: "goldReachedLTL",
  platinumTrialUserType: "platinumTrial",
  platinumUserType: "platinum",
  anonymousSubHeading: "is the leading industry source of news, insights, analysis and data for",
  bronzeNotReachedLTLSubHeading: ", as part of your access you are able to view the full profile",
  bronzeReachedLTLSubHeading:
    ", you have reached your profile limit. To unlock the full database, you will need a Platinum subscription. Need more time to decide?",
  goldNotReachedLTLSubHeading: ", as part of your access you are able to view the full profile",
  goldReachedLTLSubHeading:
    ", you have reached your profile limit. To unlock the full database, you will need a Platinum subscription. Need more time to decide?",
  platinumTrialSubHeading:
    ", as part of your database trial, you currently have full access to all profiles.",
  platinumSubHeading: ", as a Platinum subscriber you have full access to all profiles.",
  anonymousButtonText: "Get access",
  bronzeNotReachedLTLButtonText: "View full profile",
  bronzeReachedLTLButtonText: "Subscribe now",
  goldReachedLTLButtonText: "Upgrade now",
  goldNotReachedLTLButtonText: "View full profile",
  platinumTrialButtonText: "View full profile",
  platinumButtonText: "View full profile",
  ctas: {
    anonymous: {},
    bronzeNotReachedLTL: {},
    bronzeReachedLTL: {},
    goldReachedLTL: {},
    goldNotReachedLTL: {},
    platinum: {},
  },
};

export const determineUser = ({
  loggedIn,
  products
}: {
  loggedIn: boolean;
  products: string[]
}) => {
  if (loggedIn === true) {
    const productPrefix = getBrandPrefix();
    const filterProduct = products?.filter(f => f.startsWith(productPrefix))
    if (filterProduct)
      return data.platinumUserType;
    else
      return data.anonymousUserType;
  }
  else {
    // Anonymous
    return data.anonymousUserType;

  }
};

export const getCTAS = (userType: any, institutionName: string, institutionID: string) => {
  const baseURL = `${basePEIURL}/database/institution-profile/id`;
  const searchUrl = buildSearchUrl(institutionName, searchConfig);
  switch (userType) {
    case data.anonymousUserType:
      return {
        OverViewComponent: {
          ctaHeading: `Get access to ${institutionName} total`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-fund-commitments`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          heading: data.heading,
          buttonText: data.anonymousButtonText,
        },
        ContactInformationComponent: {
          ctaHeading: `Get access to all ${institutionName} contact <span class="OverViewComponent_keep-together__q8Hq_">information &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-contact-information`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
        },
        HeadlinesComponent: {
          ctaHeading: `Get access to all ${institutionName} <span class="OverViewComponent_keep-together__q8Hq_">news and analysis &gt;</span>`,
          LP: searchUrl,
          GP: searchUrl,
          "LP/GP": searchUrl,
        },
        InvestmentAppetite: {
          ctaHeading: `Get access to all ${institutionName} investment <span class="OverViewComponent_keep-together__q8Hq_">appetite &gt;</span>`,
          LP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          GP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          "LP/GP": `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
        },
        FundsManagedComponent: {
          ctaHeading: `Get access to all ${institutionName} funds <span class="OverViewComponent_keep-together__q8Hq_">managed &gt;</span>`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
        },
        FundCommitmentComponent: {
          ctaHeading: `Get access to all ${institutionName} known fund <span class="OverViewComponent_keep-together__q8Hq_">commitments &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
        },
      };

    case data.platinumUserType:
      return {
        OverViewComponent: {
          ctaHeading: `View ${institutionName} total`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-fund-commitments`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          heading: data.heading,
          buttonText: data.platinumButtonText,
        },
        ContactInformationComponent: {
          ctaHeading: `View all ${institutionName} contact  <span class="OverViewComponent_keep-together__q8Hq_">information &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-contact-information`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
        },
        HeadlinesComponent: {
          ctaHeading: `View all ${institutionName} <span class="OverViewComponent_keep-together__q8Hq_">news and analysis &gt;</span>`,
          LP: searchUrl,
          GP: searchUrl,
          "LP/GP": searchUrl,
        },
        InvestmentAppetite: {
          ctaHeading: `View all ${institutionName} investment <span class="OverViewComponent_keep-together__q8Hq_">appetite &gt;</span>`,
          LP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          GP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          "LP/GP": `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
        },
        FundsManagedComponent: {
          ctaHeading: `View all ${institutionName} funds <span class="OverViewComponent_keep-together__q8Hq_">managed &gt;</span>`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
        },
        FundCommitmentComponent: {
          ctaHeading: `View all ${institutionName} known fund <span class="OverViewComponent_keep-together__q8Hq_">commitments &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
        },
      };

    default:
      return {
        OverViewComponent: {
          ctaHeading: `Get access to ${institutionName} total`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-fund-commitments`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          heading: data.heading,
          buttonText: data.anonymousButtonText,
        },
        ContactInformationComponent: {
          ctaHeading: `Get access to all ${institutionName} contact  <span class="OverViewComponent_keep-together__q8Hq_">information &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}/lp-contact-information`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-contact-information`,
        },
        HeadlinesComponent: {
          ctaHeading: `Get access to all ${institutionName} <span class="OverViewComponent_keep-together__q8Hq_">news and analysis &gt;</span>`,
          LP: searchUrl,
          GP: searchUrl,
          "LP/GP": searchUrl,
        },
        InvestmentAppetite: {
          ctaHeading: `Get access to all ${institutionName} investment <span class="OverViewComponent_keep-together__q8Hq_">appetite &gt;</span>`,
          LP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          GP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
          "LP/GP": `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}${investmentAppetiteLink.route}`,
        },
        FundsManagedComponent: {
          ctaHeading: `Get access to all ${institutionName} funds <span class="OverViewComponent_keep-together__q8Hq_">managed &gt;</span>`,
          GP: `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}/gp-fund-managed`,
        },
        FundCommitmentComponent: {
          ctaHeading: `Get access to all ${institutionName} known fund <span class="OverViewComponent_keep-together__q8Hq_">commitments &gt;</span>`,
          LP: `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
          "LP/GP": `${baseURL}/${institutionID}/${institutionName}${lpFundCommitment}`,
        },
        SignIn: {
          LP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}/lp-fund-commitments`,
          GP: `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}/gp-fund-managed`,
          "LP/GP": `${basePEIURL}${investmentAppetiteLink.main}${institutionID}/${institutionName}/gp-fund-managed`,
        },
      };
  }
};

export function getMonthName(monthNumber: number) {
  const date = new Date();
  date.setMonth(monthNumber);
  return date.toLocaleString("en-US", {
    month: "short",
  });
}

export const numberFormat = (num: number) =>
  Intl.NumberFormat("en-US", {
    notation: "compact",
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })
    .format(num)
    .toLowerCase();

export const getConditionalStatusWithPartnerStatus = (component: string, status: string) => {
  switch (component) {
    case "LP":
      return status === partnerStatuses.LP || status === partnerStatuses["LP/GP"];
    case "GP":
      return status === partnerStatuses.GP || status === partnerStatuses["LP/GP"];
    case "fund-commitment":
      return status === partnerStatuses.LP || status === partnerStatuses["LP/GP"];
    case "investment-appetite":
      return status === partnerStatuses.LP || status === partnerStatuses["LP/GP"];
    case "funds-managed":
      return status === partnerStatuses.GP || status === partnerStatuses["LP/GP"];
    default:
      return true;
  }
};

export function getMonthByName(date: Date) {
  const getdate = new Date(date);
  return getdate.toLocaleString("default", { month: "short" });
}

export function getJustDate() {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function getBuildStatus(
  totalCount: number,
  contacts: Array<any>,
  fundCommitmentsCount: number,
  hasApetiteRecord: boolean,
  inMarketFunds: Array<any>,
  closedFunds: Array<any>,
  partnerStatus: string
) {
  let readyForBuild = false;

  switch (partnerStatus) {
    case "LP":
      if (totalCount !== 0 || contacts.length > 0 || fundCommitmentsCount > 0 || hasApetiteRecord)
        readyForBuild = true;
      break;

    case "GP":
      if (
        totalCount !== 0 ||
        contacts.length > 0 ||
        inMarketFunds.length > 0 ||
        closedFunds.length > 0
      )
        readyForBuild = true;
      break;
    case "LP/GP":
      if (
        totalCount !== 0 ||
        contacts.length > 0 ||
        fundCommitmentsCount > 0 ||
        inMarketFunds.length > 0 ||
        closedFunds.length > 0 ||
        hasApetiteRecord
      )
        readyForBuild = true;
      break;
  }

  return readyForBuild;
}

export function readFile(path: string) {
  return fs.readFileSync(path);
}

export function writeToFile(path: string, content: string) {
  fs.writeFileSync(path, content);
}

export function reCreateFile(filePath: string, content: string) {
  if (fs.existsSync(filePath)) {
    fs.unlinkSync(filePath);
  }

  if (shouldGenerateSitemap) {
    fs.writeFileSync(sitemapPath, content);
    fs.writeFileSync(removalsPath, "");
  }
}

function getTimezoneString(timezone: any) {
  const sign = timezone > 0 ? "-" : "+";
  const hours = ("0" + Math.floor(Math.abs(timezone) / 60)).slice(-2);
  const minutes = ("0" + (Math.abs(timezone) % 60)).slice(-2);
  return sign + hours + ":" + minutes;
}

export function getDateForSiteMap() {
  const date = new Date();
  const newTimeString =
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2) +
    "T" +
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2) +
    getTimezoneString(date.getTimezoneOffset());
  return newTimeString;
}

// Atomically record a slug for removal from the sitemap. The actual
// read-modify-write is deferred to scripts/postbuild.js which runs single-threaded
// after all workers have exited, eliminating the race condition that caused
// "Static worker unexpectedly exited" errors.
export function removeFromSitemap(slug: string) {
  fs.appendFileSync(removalsPath, slug + "\n");
}

export async function generateSiteMap(institution: any) {
  const includeOrNot = await pingOldProfile(institution.formatString());

  if (includeOrNot) {
    return;
  }

  removeFromSitemap(institution.formatString());
}

export async function generateSiteMapOfAllProfiles(paths: any[]) {
  try {
    console.info("Generating sitemap for all institutions...");
    await new Promise(async (resolve, reject) => {
      await fs.readFile(sitemapPath, "utf8", async (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
          return;
        }

        const parser = new XMLParser();
        let jsonObject = parser.parse(data);

        if (!jsonObject?.urlset || !jsonObject.urlset.hasOwnProperty("url")) {
          jsonObject = {
            urlset: {
              url: [],
            },
          };
        }

        if (jsonObject?.urlset && !Array.isArray(jsonObject.urlset.url)) {
          jsonObject.urlset.url = [{ ...jsonObject.urlset.url }];
        }

        paths.forEach((element) => {
          jsonObject?.urlset?.url?.push({
            loc: `${canonicalPEIURL}/institution-profiles/${element.params.Institution}.html`,
            lastmod: getDateForSiteMap(),
          });
        });

        // No-op today — every <loc> above already uses canonicalPEIURL. Defensive only:
        // normalises any foreign host before the dedup below compares raw strings.
        jsonObject = rewriteSitemapDomain(jsonObject, canonicalPEIURL);

        const seenLocs = new Set<string>();
        jsonObject.urlset.url = jsonObject?.urlset?.url?.filter((entry: { loc: string }) => {
          if (!entry.loc || seenLocs.has(entry.loc)) return false;
          seenLocs.add(entry.loc);
          return true;
        }) ?? [];

        const builder = new XMLBuilder({ format: true });
        const xmlContent = builder.build(filterSitemap(brand, jsonObject));
        const siteMapUrl = 'content_hubs-sitemap.xsl';

        const xmlItem = xmlContent
          .replace(
            "<urlset>",
            `<?xml version='1.0' encoding='UTF-8'?>\n<?xml-stylesheet type="text/xsl" href="${siteMapUrl}"?>\n<urlset xmlns='http://www.sitemaps.org/schemas/sitemap/0.9'>`
          )
          .replace("<?xml?>\n<?xml-stylesheet?>", "")
          .replace(
            "\n<?xml version='1.0' encoding='UTF-8'?>",
            "<?xml version='1.0' encoding='UTF-8'?>"
          );

        // Write the updated data back to the file
        return await fs.writeFile(sitemapPath, xmlItem, "utf8", (err: any) => {
          if (err) {
            console.error(err);
            reject(false);
          }

          resolve(true);
        });
      });
    });
  } catch (error) {
    console.log(error);
  }
}

export const generatePathsOfAssets = (name: string) => {
  switch (name) {
    case "pdi":
      return "./pdi-logo.svg";
    case "agri":
      return "./agri-logo.svg";
    case "si":
      return "./si-logo.svg";
    case "ii":
      return "./ii-logo.svg";
    case "pehub":
      return "./pehub-logo.svg";
    case "pei":
    case "npm":
    case "pdi":
    case "buyout":
      return "./pei-logo.svg";
    case "pere":
      return "./pere-logo.svg";
    case "lock":
      return "./lock.svg";
    case "user":
      return "./user.svg";
    case "marker":
      return "/marker.svg";
    default:
      return "./lock.svg";
  }
};

export const generatePathsOfLogosForBrands = (name: string) => {
  return `./${name}-logo.svg`;
};

export const shouldGenerateHtml = (buildStatus: boolean) => {
  const forceGenerate = JSON.parse(process.env.FORCE_REBUILD_HTML_FILES || "false");
  return buildStatus || forceGenerate;
};

const getBrandPrefix = () => {
  const name = window.location.hostname.split(".")[1];
  const prefixMap: { [key: string]: string } = {
    "agriinvestor": "ai",
    "buyoutsinsider": "buy",
    "infrastructureinvestor": "ii",
    "newprivatemarkets": "npm",
    "privatedebtinvestor": "pdi",
    "pehub": "pehub",
    "privateequityinternational": "pei",
    "perenews": "pere",
    "secondariesinvestor": "si"
  };
  return prefixMap[name] || name;
}
